import { render } from "./Header-video.vue?vue&type=template&id=e0e1ae1e"
import script from "./Header-video.vue?vue&type=script&lang=js"
export * from "./Header-video.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__